var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 2L4.7 0.5H0V14.5H14V2H6.2ZM13 5V13.5H1V5H2V4H1V1.5H4.3L5.8 3H13V4H3V5H13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4999 7.79844V10.4984H7.4999V7.79844L8.3999 8.69844L9.0999 7.99844L6.9999 5.89844L4.8999 7.99844L5.5999 8.69844L6.4999 7.79844Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 10.5H8.99951V11.5H4.99951V10.5H3.99951V12.5H9.99951V10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteUploadIcon);
export default __webpack_public_path__ + "static/media/site-upload-icon.a93c827fd1a34b5f0de391e4a01d64c2.svg";
export { ForwardRef as ReactComponent };